module.exports = __webpack_public_path__ + "static/media/rsScreenShot02.ba2beebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/rsScreenShot02.png
// module id = 573
// module chunks = 0